"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const floating_vue_1 = require("floating-vue");
let ReportExpanded = class ReportExpanded extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.reportRankNumbers = [
            'No disponible',
            'Muy Bajo',
            'Bajo',
            'Medio',
            'Alto',
            'Muy Alto',
        ];
    }
    reportItemColor(rank) {
        return `bmfw-rank-decorator--${rank}`;
    }
    reportRank(rank) {
        return this.reportRankNumbers[rank];
    }
    reportName(index) {
        if (index == 'shi_rank')
            return 'SOIL QUALITY';
        if (index == 'biodiversity_rank')
            return 'BIODIVERSITY';
        if (index == 'functionality_rank')
            return 'FUNCTIONALITY';
        if (index == 'resistance_rank')
            return 'RESISTANCE';
        if (index == 'healthiness_rank')
            return 'HEALTHINESS';
        if (index == 'biocontrol_rank')
            return 'BIOCONTROL';
        if (index == 'hormoneprod_rank')
            return 'HORMONE PROD';
        if (index == 'stressadapt_rank')
            return 'STRESS ADAPT';
        if (index == 'nutrition_c_rank')
            return 'C';
        if (index == 'nutrition_n_rank')
            return 'N';
        if (index == 'nutrition_p_rank')
            return 'P';
        if (index == 'nutrition_k_rank')
            return 'K';
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ReportExpanded.prototype, "becropReport", void 0);
ReportExpanded = __decorate([
    (0, vue_property_decorator_1.Options)({ components: { Dropdown: floating_vue_1.Dropdown } })
], ReportExpanded);
exports.default = ReportExpanded;
